import React, { useEffect, useMemo, useState } from "react";
import { StepUpSpinner } from "../../../Components/Loader";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Button,
  TextField,
  InputAdornment,
  Card,
  Typography,
  CardContent,
  Collapse,
  IconButton,
  Divider,
} from "@mui/material";
import {
  useDeleteEmailMutation,
  useGetEmailQuery,
  useGetEmailTemplatesQuery,
} from "../../../Api/attoDeskApi";
import { IEmail } from "../../../Api/Interface/api.interface";
import NewPopUpDepartment from "../Edit/index";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import { useNotifier } from "../../../Core/Notifier";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { CiSearch } from "react-icons/ci";
import { Link, useNavigate } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import Pagination from "../../../Components/Pagination";
import { toProperCase } from "../../../Components/Validation/toProperCase";
import {
  EmailTemplateOption,
  IEmailTemplet,
} from "../../../Api/Interface/api.interface";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import useIsMobile from "../../../Core/hook/useIsMobile";

const ExpandMore = styled((props: any) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }: any) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const debouncedSearchQuery = useDebounce(searchQuery, 300);

  const [selectedCoursing, setSelectedCoursing] = useState<IEmail | null>(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] = useState<IEmail | null>(null);

  const isMobileRes = useIsMobile();

  const [expandedTemplateId, setExpandedTemplateId] = useState<string | null>(
    null
  );

  const { data, isLoading, isError, refetch } = useGetEmailQuery({
    searchText: currentSearchQuery,
  });

  const { data: userroleData, isLoading: userroleIsLoading } =
    useGetEmailTemplatesQuery({
      searchText: "",
    });

  const userroleList = useMemo(() => {
    return userroleData?.data as IEmailTemplet[];
  }, [userroleData?.data]);

  useEffect(() => {
    if (debouncedSearchQuery.length >= 4 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleOpenDialog = (coursing: IEmail) => {
    setSelectedCoursing(coursing);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedCoursing(null);
    setOpenDialog(false);
  };

  const handleOpenDeletePopup = (coursing: IEmail) => {
    setCoursingToDelete(coursing);
    setOpenDeleteCategory(true);
  };

  const handleCloseDeletePopup = () => {
    setCoursingToDelete(null);
    setOpenDeleteCategory(false);
  };

  const [deleteCategory] = useDeleteEmailMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpenDeleteCategory(false);
      } else {
        showErrorMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Failed to delete the email");
    }
  };

  const coursings: IEmail[] = Array.isArray(data?.data)
    ? (data?.data as IEmail[])
    : [];

  const handleAddProductClick = () => {
    navigate("/email/setting/create");
  };

  const handleTempletClick = () => {
    navigate("/email/template/create");
  };

  const toggleExpand = (id: string) => {
    setExpandedTemplateId((prev) => (prev === id ? null : id));
  };

  return (
    <div>
      <Grid container spacing={3}>
        {isMobileRes ? (
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={2}
                    sx={{ padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Grid
                        container
                        spacing={1}
                        justifyContent="flex-end"
                        sx={{ display: "flex" }}
                      >
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <CiSearch
                                    className={classes.searchWidgetIcon}
                                  />
                                </InputAdornment>
                              ),
                              classes: {
                                root: classes.formControlList,
                              },
                            }}
                            fullWidth
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            placeholder="Email .."
                            className={classes.searchTextField}
                            size="small"
                          />
                        </Grid>
                        <Grid item>
                          <Button
                            // variant="contained"
                            className={classes.addNewButton}
                            onClick={handleTempletClick}
                          >
                            Template
                          </Button>
                        </Grid>
                        <Grid item>
                          <Button
                            // variant="contained"
                            className={classes.addNewButton}
                            onClick={handleAddProductClick}
                          >
                            Add New
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid>
                    <TableContainer>
                      <Table className={classes.table}>
                        <TableHead className={classes.tableHeaderRow}>
                          <TableRow>
                            <TableCell className={classes.tablheader}>
                              <strong>E-mail</strong>
                            </TableCell>
                            <TableCell
                              className={classes.tablheader}
                              sx={{ textAlign: "right" }}
                            >
                              <strong>Actions</strong>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {isLoading ? (
                            <TableRow>
                              <TableCell colSpan={20} align="center">
                                <Box display="flex" justifyContent="center" alignItems="center" height="10vh">
                      <StepUpSpinner size="medium" />
                    </Box>
                              </TableCell>
                            </TableRow>
                          ) : isError || coursings.length === 0 ? (
                            <TableRow>
                              <TableCell colSpan={20} align="center">
                                {isError
                                  ? "Error fetching data"
                                  : "No data available"}
                              </TableCell>
                            </TableRow>
                          ) : (
                            coursings
                              .slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage
                              )
                              .map((row: IEmail, index) => (
                                <TableRow
                                  key={row.id}
                                  className={classes.tableRowHover}
                                >
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    className={classes.tablCell}
                                  >
                                    <Typography>{row.email}</Typography>

                                    <Typography
                                      className={classes.mobileListText}
                                    >
                                      {Array.isArray(row.multipleType) &&
                                      row.multipleType.length > 0
                                        ? row.multipleType.join(", ")
                                        : ""}
                                    </Typography>
                                  </TableCell>
                                  <TableCell className={classes.tablCell}>
                                    <Grid
                                      container
                                      spacing={1}
                                      sx={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                      }}
                                    >
                                      <Grid item>
                                        <Button
                                          // variant="contained"
                                          className={classes.editButtonList}
                                          onClick={() => handleOpenDialog(row)}
                                        >
                                          <EditSharpIcon
                                            className={classes.editListIcon}
                                          />
                                        </Button>
                                      </Grid>
                                      <Grid item>
                                        <Button
                                          // variant="contained"
                                          className={classes.deleteButtonList}
                                          onClick={() =>
                                            handleOpenDeletePopup(row)
                                          }
                                        >
                                          <DeleteOutlineSharpIcon
                                            className={classes.editListIcon}
                                          />
                                        </Button>
                                      </Grid>
                                    </Grid>
                                  </TableCell>
                                </TableRow>
                              ))
                          )}
                        </TableBody>
                      </Table>
                      <Grid
                        spacing={5}
                        p={"18px"}
                        py={4}
                        justifyContent={"end"}
                        container
                        textAlign={"center"}
                        alignContent={"center"}
                        alignItems={"center"}
                      >
                        <Grid
                          sx={{
                            textAlign: "end",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                          }}
                        >
                          <Pagination
                            count={coursings.length}
                            page={page}
                            rowsPerPage={rowsPerPage}
                            onPageChange={handleChangePage}
                          />
                        </Grid>
                      </Grid>
                    </TableContainer>
                    {selectedCoursing && (
                      <NewPopUpDepartment
                        openModel={openDialog}
                        handleCloseDialog={handleCloseDialog}
                        data={selectedCoursing}
                      />
                    )}
                    {coursingToDelete && (
                      <DeletePopup
                        open={openDeleteCategory}
                        handleCloseDelete={handleCloseDeletePopup}
                        onConfirm={async () => {
                          await handleDelete(coursingToDelete.id.toString());
                        }}
                        title="Delete Email"
                        content={`Are you sure you want to delete "${coursingToDelete.email}"?`}
                      />
                    )}
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Grid
                        container
                        spacing={1}
                        justifyContent="flex-end"
                        sx={{ display: "flex" }}
                      >
                        <Grid item>
                          <TextField
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <CiSearch
                                    className={classes.searchWidgetIcon}
                                  />
                                </InputAdornment>
                              ),
                              classes: {
                                root: classes.formControlList,
                              },
                            }}
                            fullWidth
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            placeholder="Email .."
                            className={classes.searchTextField}
                            size="small"
                          />
                        </Grid>
                        <Grid item>
                          <Button
                            // variant="contained"
                            className={classes.addNewButton}
                            onClick={handleTempletClick}
                          >
                            Template
                          </Button>
                        </Grid>
                        <Grid item>
                          <Button
                            // variant="contained"
                            className={classes.addNewButton}
                            onClick={handleAddProductClick}
                          >
                            Add New
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid>
                    <TableContainer>
                      <Table className={classes.table}>
                        <TableHead className={classes.tableHeaderRow}>
                          <TableRow>
                            <TableCell className={classes.tablheader}>
                              <strong>E-mail</strong>
                            </TableCell>
                            <TableCell
                              className={classes.tablheader}
                              // sx={{ textAlign: "center" }}
                            >
                              <strong>Type</strong>
                            </TableCell>
                            <TableCell
                              className={classes.tablheader}
                              sx={{ textAlign: "right" }}
                            >
                              <strong>Actions</strong>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {isLoading ? (
                            <TableRow>
                              <TableCell colSpan={20} align="center">
                                <Box display="flex" justifyContent="center" alignItems="center" height="10vh">
                      <StepUpSpinner size="medium" />
                    </Box>
                              </TableCell>
                            </TableRow>
                          ) : isError || coursings.length === 0 ? (
                            <TableRow>
                              <TableCell colSpan={20} align="center">
                                {isError
                                  ? "Error fetching data"
                                  : "No data available"}
                              </TableCell>
                            </TableRow>
                          ) : (
                            coursings
                              .slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage
                              )
                              .map((row: IEmail, index) => (
                                <TableRow
                                  key={row.id}
                                  className={classes.tableRowHover}
                                >
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    className={classes.tablCell}
                                  >
                                    {row.email}
                                  </TableCell>
                                  <TableCell
                                    scope="row"
                                    className={classes.tablCell}
                                    // sx={{ textAlign: "center" }}
                                  >
                                    {Array.isArray(row.multipleType) &&
                                    row.multipleType.length > 0
                                      ? row.multipleType.join(", ")
                                      : ""}
                                  </TableCell>
                                  <TableCell className={classes.tablCell}>
                                    <Grid
                                      container
                                      spacing={1}
                                      sx={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                      }}
                                    >
                                      <Grid item>
                                        <Button
                                          // variant="contained"
                                          className={classes.editButtonList}
                                          onClick={() => handleOpenDialog(row)}
                                        >
                                          <EditSharpIcon
                                            className={classes.editListIcon}
                                          />
                                        </Button>
                                      </Grid>
                                      <Grid item>
                                        <Button
                                          // variant="contained"
                                          className={classes.deleteButtonList}
                                          onClick={() =>
                                            handleOpenDeletePopup(row)
                                          }
                                        >
                                          <DeleteOutlineSharpIcon
                                            className={classes.editListIcon}
                                          />
                                        </Button>
                                      </Grid>
                                    </Grid>
                                  </TableCell>
                                </TableRow>
                              ))
                          )}
                        </TableBody>
                      </Table>
                      <Grid
                        spacing={5}
                        p={"18px"}
                        py={4}
                        justifyContent={"end"}
                        container
                        textAlign={"center"}
                        alignContent={"center"}
                        alignItems={"center"}
                      >
                        <Grid
                          sx={{
                            textAlign: "end",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                          }}
                        >
                          <Pagination
                            count={coursings.length}
                            page={page}
                            rowsPerPage={rowsPerPage}
                            onPageChange={handleChangePage}
                          />
                        </Grid>
                      </Grid>
                    </TableContainer>
                    {selectedCoursing && (
                      <NewPopUpDepartment
                        openModel={openDialog}
                        handleCloseDialog={handleCloseDialog}
                        data={selectedCoursing}
                      />
                    )}
                    {coursingToDelete && (
                      <DeletePopup
                        open={openDeleteCategory}
                        handleCloseDelete={handleCloseDeletePopup}
                        onConfirm={async () => {
                          await handleDelete(coursingToDelete.id.toString());
                        }}
                        title="Delete Email"
                        content={`Are you sure you want to delete "${coursingToDelete.email}"?`}
                      />
                    )}
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </Grid>
        )}

        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Card className={classes.card} sx={{ minHeight: 300 }}>
            <Grid
              container
              justifyContent={"space-between"}
              spacing={3}
              sx={{ borderBottom: 2, padding: 2 }}
              className={classes.titleGrid}
            >
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                pt={2}
                alignContent={"center"}
              >
                <Typography className={classes.cardTitle}>Templates</Typography>
              </Grid>
            </Grid>
            <Grid container spacing={3} p={2}>
              {userroleList?.length ? (
                userroleList.map((template) => (
                  <Grid item xs={12} md={12} lg={12} key={template.id}>
                    <Card variant="outlined" className={classes.card}>
                      <CardContent
                        onClick={() => toggleExpand(template.id)}
                        sx={{ cursor: "pointer" }}
                      >
                        <Grid
                          container
                          alignItems="center"
                          justifyContent="space-between"
                        >
                          <Grid item xs>
                            <Typography
                              variant="subtitle1"
                              fontWeight={600}
                              sx={{ cursor: "pointer" }}
                              onClick={() => toggleExpand(template.id)}
                            >
                              {template.template_name}
                            </Typography>
                          </Grid>
                          <Grid item>
                            <ExpandMore
                              expand={expandedTemplateId === template.id}
                              onClick={() => toggleExpand(template.id)}
                              aria-expanded={expandedTemplateId === template.id}
                            >
                              <ExpandMoreIcon />
                            </ExpandMore>
                          </Grid>
                        </Grid>
                        <Grid
                          container
                          alignItems="center"
                          justifyContent="space-between"
                        >
                          <Grid item lg={11} md={10} sm={12} xs={12}>
                            <Typography
                              variant="body2"
                              color="textSecondary"
                              mt={1}
                              noWrap
                            >
                              Subject: {template.subject}
                            </Typography>
                          </Grid>
                          <Grid item lg={1} md={12} sm={12} xs={12}>
                            <Grid
                              container
                              spacing={1}
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Link
                                to={`/email/template/create/?${template.id}`}
                                className={classes.iconLinkPropNormal}
                              >
                                <Grid item>
                                  <Button className={classes.editButtonList}>
                                    <EditSharpIcon
                                      className={classes.editListIcon}
                                    />
                                  </Button>
                                </Grid>
                              </Link>
                            </Grid>
                          </Grid>
                        </Grid>
                      </CardContent>

                      <Collapse
                        in={expandedTemplateId === template.id}
                        timeout="auto"
                        unmountOnExit
                      >
                        <Divider />
                        <CardContent>
                          <Typography
                            component="div"
                            dangerouslySetInnerHTML={{
                              __html: template.message,
                            }}
                          />
                        </CardContent>
                        {template?.attachments &&
                          template?.attachments.length > 0 && (
                            <CardContent sx={{ pt: 2 }}>
                              <Typography
                                variant="subtitle2"
                                fontWeight={600}
                                gutterBottom
                              >
                                Attachments:
                              </Typography>
                              <Grid container spacing={2}>
                                {(() => {
                                  return template?.attachments.map(
                                    (file, index) => {
                                      const isImage =
                                        /\.(jpeg|jpg|png|gif|webp)$/i.test(
                                          file
                                        );
                                      const isPdf = /\.pdf$/i.test(file);
                                      const isVideo = /\.mp4$/i.test(file);

                                      return (
                                        <Grid item key={index}>
                                          <a
                                            href={file}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                              cursor: "pointer",
                                              // display: "inline-block",
                                            }}
                                          >
                                            {isImage && (
                                              <img
                                                src={file}
                                                alt={`attachment-${index}`}
                                                style={{
                                                  width: 200,
                                                  height: 200,
                                                  border: "1px solid #ccc",
                                                }}
                                              />
                                            )}
                                            {isPdf && (
                                              <div
                                                style={{
                                                  border: "1px solid #ccc",
                                                  width: 200,
                                                  height: 200,
                                                }}
                                              >
                                                <object
                                                  data={file}
                                                  type="application/pdf"
                                                  style={{
                                                    // border: "1px solid #ccc",
                                                    width: 200,
                                                    height: 150,
                                                  }}
                                                ></object>
                                                <p>
                                                  <a
                                                    href={file}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                  >
                                                    Click here to download
                                                  </a>
                                                </p>
                                              </div>
                                            )}
                                            {isVideo && (
                                              <video
                                                controls
                                                style={{
                                                  width: 200,
                                                  height: 200,
                                                  border: "1px solid #ccc",
                                                }}
                                              >
                                                <source
                                                  src={file}
                                                  type="video/mp4"
                                                />
                                                Your browser does not support
                                                the video tag.
                                              </video>
                                            )}
                                            {!isImage && !isPdf && !isVideo && (
                                              <a
                                                href={file}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                  textDecoration: "none",
                                                }}
                                              >
                                                <Typography color="primary">
                                                  Download File {index + 1}
                                                </Typography>
                                              </a>
                                            )}
                                          </a>
                                        </Grid>
                                      );
                                    }
                                  );
                                })()}
                              </Grid>
                            </CardContent>
                          )}
                      </Collapse>
                    </Card>
                  </Grid>
                ))
              ) : (
                <Grid item xs={12}>
                  <Typography textAlign="center">
                    No templates found.
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default Index;
